
import { Component, Vue, Prop } from 'vue-property-decorator'
import lsPagination from '@/components/ls-pagination.vue'
import { RequestPaging } from '@/utils/util'
import { apiScoreList, apiScoreAudit, apiScoreTurn } from '@/api/score'
@Component({
    components: {
        lsPagination
    }
})
export default class AiList extends Vue {
    $refs!: any
    tableData: Array<object> = []
    AuditTime: Array<object> = []
    pager = new RequestPaging()
    scoreappleVisible: Boolean = false //查看
    scoreGrant: Boolean = false //发放
    params: any = {
        id: '',
        status: 2
    }
    scoreReject: Boolean = false // 驳回
    Rejects: any = {
        id: '',
        status: 3
    }
    search: any = {
        status: '',
        start_time: '', //申请时间开始
        end_time: '', //申请时间结束
        start_audit_time: '', //审核时间开始
        end_audit_time: '', //审核时间结束
        status_str: '', //状态
        shop_name: '' //公司名称
    }
    viewListApply: any = {}
    url: any = ''
    handleCurrentChange(val: any) {
        this.viewListApply = val
        this.url = val.voucher
        this.params.id = val.id
        this.Rejects.id = val.id
    }
    // 拆分时间
    splitStartTime() {
        if (this.tableData != null) {
            this.search.start_time = this.tableData[0]
            this.search.end_time = this.tableData[1]
        }
    }
    splitAuditTime() {
        if (this.AuditTime != null) {
            this.search.start_audit_time = this.AuditTime[0]
            this.search.end_audit_time = this.AuditTime[1]
        }
    }
    //申请列表
    searchview() {
        this.pager
            .request({
                callback: apiScoreList,
                params: {
                    ...this.search
                }
            })
            .then(res => {})
    }
    //查看
    scoreView() {
        this.scoreappleVisible = true
    }
    //发放
    scoreviewGrant() {
        this.scoreGrant = true
    }
    //驳回
    scoreviewReject() {
        this.scoreReject = true
    }
    //发放积分
    scoreGrants() {
        this.scoreGrant = false
        apiScoreAudit(this.params)
            .then((res: any) => {
                this.$alert('您发放' + this.viewListApply.score + '个积分', '发放成功', {
                    confirmButtonText: '确定',
                    //   center: true,
                    callback: action => {
                        this.$message({
                            type: 'success',
                            message: `发放成功`
                        })
                    }
                })
                this.searchview()
            })
            .catch(err => {
                //   this.$message.error(err.message)
                //   console.log(err)
            })
    }
    //驳回申请
    scoreviewRejects() {
        this.scoreReject = false
        apiScoreAudit(this.Rejects)
            .then((res: any) => {
                this.$alert('您已成功驳回本次申请', '驳回成功', {
                    confirmButtonText: '确定',
                    //   center: true,
                    callback: action => {
                        this.$message({
                            type: 'success',
                            message: `驳回成功`
                        })
                    }
                })
                this.searchview()
            })
            .catch(err => {})
    }
    searchSelect(value: any) {
        this.search.status = value
    }
    //重置表单
    reset() {
        Object.keys(this.search).map(key => {
            this.$set(this.search, key, '')
        })
        this.searchview()
    }
    created() {
        this.searchview()
    }
}
